import React, { useState, useRef } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'

import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import Chip from '@material-ui/core/Chip'


import godJson from '../game-data/gods.json'


const useStyles = makeStyles(theme => ({
  placeholder: { color: 'grey' },
  boonImg: { maxHeight: '50px' },
  godImg: { maxHeight: '30px' },
  restriction: { color: 'red' },
  prereq: {
    display: 'flex',
    border: '1px solid grey',
    padding: theme.padding,
    margin: theme.margin,
    flexWrap: 'wrap',
    alignItems: 'center'
  },
  prereqChild: {
    padding: theme.padding,
    color: 'grey',
  },
  valid: { color: 'green' },
  prereqChildParent: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.padding,
    margin: theme.margin,
    borderRadius: '4px',
    border: '1px solid rgba(255, 255, 255, 0.23)',
    boxShadow: '0px 5px 5px -3px rgb(0 0 0 / 20%), 0px 8px 10px 1px rgb(0 0 0 / 14%), 0px 3px 14px 2px rgb(0 0 0 / 12%)',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    borderBottom: '0.5px solid rgba(255, 255, 255, 0.23)',
    padding: theme.padding,
    margin: theme.margin,
  },
  body: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly'
  },
  tooltip: {
    position: 'absolute',
    padding: theme.padding,
    borderRadius: '4px',
    border: `1px solid ${theme.palette.secondary.main}`,
    backgroundColor: theme.palette.background.paper,
    zIndex: 99999,
  },
  want: {
    display: 'flex',
    justifyContent: 'space-between',
    '& > button': { alignSelf: 'center' }
  },
  boonWantImg: { maxHeight: '30px' }
}))

const PREREQ_TYPES = {
  'all': 'All:',
  'one of': 'One of:',
  'one of each': 'One of each:',
  'two of three': 'Two of three:',
  'unique to': 'Unique to:',
}

/*
  ====[TODO]
  prereq highlighting somewhere else? e.g. the slot
  effects
*/

const BoonCard = ({
  name,
  description = '',
  gods = [],
  img_url,
  currentPrerequisites,
  currentRestrictions,
  slot,
  placeholder,
  valid,
  wantBoon,
  haveClick,
  wantClick,
  removeClick,
  children,
}) => {
  const classes = useStyles()
  const image = img_url || 'https://static.wikia.nocookie.net/hades_gamepedia_en/images/e/e3/Cerberus-bond-forged.png'
  const prereqIcon = useRef()
  const [showTooltip, setShowTooltip] = useState(false)
  const handleShowTooltip = () => setShowTooltip(true)
  const handleHideTooltip = () => setShowTooltip(false)

  return (
    <div className={clsx([classes.container, { [classes.placeholder]: placeholder }])}>
      <div className={classes.header}>
        <img alt={name} className={classes.boonImg} src={image} />
        <Typography variant='body1'>{name || slot}</Typography>
        {gods.map(name => <img alt={name} key={name} src={godJson[name].symbol_url} className={classes.godImg} />)}
      </div>
      <Typography variant='body2'>{description}</Typography>
      <div className={classes.body}>
        {!valid && name && <div
          onMouseEnter={handleShowTooltip}
          onMouseLeave={handleHideTooltip} 
        >
          <Chip
            clickable
            label='invalid'
            variant='outlined'
            ref={prereqIcon}
          />
          {showTooltip && (currentRestrictions?.values?.length || currentPrerequisites?.values) && (
            <div className={classes.tooltip}>
              {currentRestrictions?.values?.length > 0 && (<div className={classes.restriction}>
                {currentRestrictions.values.filter(o => o.present).map(o => <p key={o.name}>{o.name}</p>)}
              </div>)}
              {currentPrerequisites?.values && (
                <div>
                  <Typography variant='body2'>{PREREQ_TYPES[currentPrerequisites.type]}</Typography>
                  <div className={classes.prereq}>
                    {currentPrerequisites.values.map((o, i) => {
                      if (o.name) {
                        return <div className={classes.prereqChild} key={o.name}><p className={clsx({ [classes.valid]: o.valid })}>{o.name}</p></div>
                      }
                      return (
                        <div key={`${name}-${o.type}-prereq-${i}`} className={classes.prereq}>
                          <Typography variant='body2'>{PREREQ_TYPES[o.type]}</Typography>
                          <div className={classes.prereqChildParent}>
                            {o.values.map(({ name, valid }) => (
                              <div className={classes.prereqChild} key={name}>
                                <p className={clsx({ [classes.valid]: valid })}>{name}</p>
                              </div>
                            ))}
                          </div>
                        </div>
                      )
                    })}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>}
        {haveClick && name && !slot && <Button size='small' variant='contained' color='primary' onClick={haveClick(name)}>have</Button>}
        {wantClick && name && <Button size='small' variant='contained' color='primary' onClick={wantClick(name)}>want</Button>}
        {removeClick && name && <Button size='small' variant='contained' color='primary' onClick={removeClick(name)}>remove</Button>}
      </div>
      {wantBoon && (<div className={classes.want}>
        <img alt={wantBoon.name} className={classes.boonWantImg} src={wantBoon.img_url} />
        <p>{name && <strong>Sell and swap for: </strong>}{wantBoon.name}</p>
        {haveClick && <Button size='small' variant='outlined' onClick={haveClick(wantBoon.name)}>have</Button>}
      </div>)}
      {children}
    </div>
  )
}

export default BoonCard
